import * as React from "react";

import {pluralize, capitalize} from "inflection";

import CatalogSummary from "../Catalog/Summary";

import connectToList from "../../store/list";

import GenSidebarContainer from "../Gen/SidebarContainer";
import GenSidebarListControls from "../Gen/SidebarListControls";
import GenCheckboxesFilter from "../Gen/CheckboxesFilter";
import GenMore from "../Gen/More";

import useConnectedListHistory from "../../hooks/useConnectedListHistory";

interface CatalogListProps {
  document_set_id: number
  documentSets: ConnectedList<DocumentSetSnakeModel>
}

function CatalogList(
  {
    document_set_id,
    documentSets,
  }: CatalogListProps,
) {
  useConnectedListHistory("documentSets", documentSets);

  React.useEffect(() => {
    documentSets.mountList(`/document_sets/${document_set_id}/document_sets`);
  }, []);

  return (
    <GenSidebarContainer>
      <GenSidebarListControls
        connectedList={documentSets}
        title={capitalize(pluralize(i18n.t("catalog")))}
        search
        searchPlaceholder="Search..."
      >
        <GenCheckboxesFilter
          {...documentSets}
          filterKey="categories"
          title="Tags"
          displayLikeFilterGroup
          dataType="MDATA"
          dataCount="MDATA_MANY"
          options={[
            "Cardiovascular",
            "Dermatology",
            "EENT",
            "Emergency Medicine",
            "Endocrinology",
            "Family Medicine",
            "Gastroenterology",
            "Geriatrics",
            "Interdisciplinary",
            "Musculoskeletal",
            "Nephrology",
            "Neurology",
            "Nursing",
            "OB/GYN",
            "Pediatrics",
            "Physician Assistant",
            "Psychology",
            "Pulmonology",
          ]}
        />
        <GenCheckboxesFilter
          {...documentSets}
          filterKey="difficulty"
          title="Tags"
          displayLikeFilterGroup
          dataType="REGULAR"
          options={[
            {
              displayName: "Easy",
              value: 1,
            },
            {
              displayName: "Intermediate",
              value: 2,
            },
            {
              displayName: "Hard",
              value: 3,
            },
          ]}
        />
      </GenSidebarListControls>
      <div className="flex-grow">
        <div className="gen-list-grid">
          {
            documentSets.listData?.map((documentSet) => <CatalogSummary documentSet={documentSet} key={documentSet.id} />)
          }
        </div>
        { !!documentSets.listData && documentSets.listData.length == 0 && <div key="no-items" className="gen-list-no-items"><h1>No Items</h1></div> }
        <div className="flex justify-center">
          <GenMore
            {...documentSets}
            shouldInfiniteScroll
          />
        </div>
      </div>
    </GenSidebarContainer>
  );
}

export default connectToList(CatalogList, ["documentSets"]);
